import React from 'react';
import { BrokerGroupDrawer } from './BrokerGroupDrawer';
import { AdminConfirmProvider } from '../shared/AdminConfirmProvider';
import { useAdminListParams } from '../shared/useAdminListParams';
import { AdminListToolbar } from '../shared/AdminListToolbar';
import { getBrokerGroupFilters } from './BrokerGroupsTable/BrokerGroupFilters';
import { BrokerGroupsTable } from './BrokerGroupsTable';

/**
 * Admin broker groups list: the toolbar (search and filters), the broker groups grid
 * (BrokerGroupsTable) and the edit drawer. Clicking a row opens its drawer (the
 * :brokerGroupId route; BrokerGroupDrawer is always rendered so it can animate).
 */
export const BrokerGroupsListPage = () => {
	const { gridProps, search, setSearch, filters, setFilter, clearFilters } =
		useAdminListParams('brokerGroups');

	return (
		<AdminConfirmProvider>
			<AdminListToolbar
				search={search}
				onSearchChange={setSearch}
				filters={getBrokerGroupFilters({ filters, setFilter })}
				onClearFilters={clearFilters}
			/>
			<BrokerGroupsTable search={search} filters={filters} gridProps={gridProps} />
			<BrokerGroupDrawer />
		</AdminConfirmProvider>
	);
};
